// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { _createTracer } from "./tracer";
/**
 * @internal
 * Create a trace implementation with tracer caching.
 * @param core - The ApplicationInsights core instance
 * @returns A trace object
 */
export function _createTracerProvider(host) {
    var tracers = {};
    return {
        getTracer: function (name, version) {
            var tracerKey = (name || "ai-web") + "@" + (version || "unknown");
            if (!tracers[tracerKey]) {
                tracers[tracerKey] = _createTracer(host);
            }
            return tracers[tracerKey];
        },
        forceFlush: function () {
            // Nothing to flush
            return;
        },
        shutdown: function () {
            // Just clear the locally cached IOTelTracer instances so they can be garbage collected
            tracers = {};
            host = null;
            return;
        }
    };
}
//# sourceMappingURL=tracerProvider.js.map